"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.u1F378 = void 0;
var u1F378 = {
  "viewBox": "0 0 2600 2760.837",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1404 1984.5q1 70.5 1 68.5 0 107 174 169t174 129q0 55-131.5 92t-358.5 37q-153 0-271.5-38.5T873 2342q0-28 30.5-55.5T975 2239l39-18 76-33q39-15 71.5-48t45-70.5 12.5-83.5v-76q-2-124-9.5-208t-14.5-132.5-60.5-105.5-92.5-91l-75-64q8 7-289-240T381 700q0-120 256.5-194t662.5-74q119 0 228 7t206 20q109-125 211-189t147-64q23 0 39 18t16 44q0 15-11 26.5t-29 20.5l-18 9q-63 29-118 69t-105 90q169 33 261 89.5t92 127.5q0 47-39 99.5T2076 924t-233.5 209.5-253.5 210-124.5 125-50.5 161-11 242.5q0 42 1 112.5zM857 822q55-28 170-44t254-16q79 0 139 3t109 9q31-56 59.5-105t63.5-101q-75-8-162-13t-190-5q-242 0-415 25.5T616 636t-116 64q14 26 106.5 62T857 822zm551 1449l-14-13q-18-15-46-46.5t-44-68.5q-33 67-89.5 108t-98.5 56.5-68 27.5q42 15 97.5 21t117.5 6q88 0 125-14.5t37-46.5q0-8-5-15.5t-12-14.5zm478-1328q21-18 40-37-124 32-284 48t-342 16q-184 0-345-16.5T670 906q90 80 167 146t152 126l111 90q44 35 96.5 54.5T1303 1342q87 0 192.5-74.5T1698 1106l143-125zm214-243q-19-27-106.5-59.5T1773 584q-41 51-74.5 102.5T1637 795q25 6 48 13l47 16q152-21 254.5-59t113.5-65zm-670 357q44 41 44 100t-44 100-104 41q-61 0-105-41t-44-100 44-100 105-41q60 0 104 41z"
    },
    "children": []
  }]
};
exports.u1F378 = u1F378;